import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

function useBreakpoints() {
  const theme = useTheme();

  const isXs = useMediaQuery(theme.breakpoints.up('xs')); // extra-small: 0px
  const isSm = useMediaQuery(theme.breakpoints.up('sm')); // small: 600px
  const isMd = useMediaQuery(theme.breakpoints.up('md')); // medium: 900px
  const isLg = useMediaQuery(theme.breakpoints.up('lg')); // large: 1200px
  const isXl = useMediaQuery(theme.breakpoints.up('xl')); // extra-large: 1536px

  return { isXs, isSm, isMd, isLg, isXl };
}

export default useBreakpoints;
